var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Partner")]), _c('div', {
    staticClass: "mb-6 max-w-sm"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": true
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama",
      "placeholder": "Masukan nama user"
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jenis Kelamin")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.genderList,
      "default": _vm.selectedGender,
      "optionLabel": "label",
      "placeholder": "Pilih jenis kelamin"
    },
    model: {
      value: _vm.selectedGender,
      callback: function ($$v) {
        _vm.selectedGender = $$v;
      },
      expression: "selectedGender"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "label": "No Handphone",
      "placeholder": "Masukan no handphone"
    },
    model: {
      value: _vm.payloads.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "phone_number", $$v);
      },
      expression: "payloads.phone_number"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Role")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.roleList,
      "defaultValue": _vm.selectedRole,
      "placeholder": "Pilih role",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedRole,
      callback: function ($$v) {
        _vm.selectedRole = $$v;
      },
      expression: "selectedRole"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Alamat Email",
      "placeholder": "Alamat Email"
    },
    model: {
      value: _vm.payloads.email,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "email", $$v);
      },
      expression: "payloads.email"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:w-full mdmax:flex-auto"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Buat Akun")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Username",
      "placeholder": "Username"
    },
    model: {
      value: _vm.payloads.username,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "username", $$v);
      },
      expression: "payloads.username"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Password")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": _vm.passwordState.fieldType,
      "placeholder": "Masukan password"
    },
    model: {
      value: _vm.payloads.password,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "password", $$v);
      },
      expression: "payloads.password"
    }
  }), _c('span', {
    staticClass: "inline-block cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2",
    on: {
      "click": function ($event) {
        return _vm.showPassword(_vm.passwordState);
      }
    }
  }, [_c(_vm.passwordState.icon, {
    tag: "component"
  })], 1)], 1)])])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }